import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { fromSettingsDtoToModel } from 'src/Libs/wallboxes/transformers/'
import { WallboxConfigurationDto } from 'src/Libs/wallboxes/api'
import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { isUndefined } from 'lodash'

const SERVICE_ID = '[WALLBOX CONFIGURATION]'

/**
 * This hook provides the utils for the PowerMeter API through a websocket connection
 */
const useLiveWallboxConfiguration = (storageId: string | undefined, wallboxKey: string | undefined): SocketStateModel<WallboxConfigurationModel> => {
  const resourcePath = `wallboxes/${storageId}/${wallboxKey}/configuration/ws`

  const { socketState } = useWebSocketApi<WallboxConfigurationModel, WallboxConfigurationDto>({
    apiResourcePath: resourcePath,
    loggerKey: SERVICE_ID,
    transformer: fromSettingsDtoToModel,
    doNotInitialize: isUndefined(storageId) || isUndefined(wallboxKey) || isNaN(parseInt(wallboxKey)),
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  return socketState
}

export default useLiveWallboxConfiguration
